import React, {useState, useEffect} from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';

export const Time = ({onChange, defaultValue, index}) => {
    const removeLastChar = (str) => {
      if (str.length) {
        return str.substring(0, str.length - 1)
      }
    }
    const [startTime, setStartTime] = useState(new Date('2020-06-18T00:00:54'));
    const [endTime, setEndTime] = useState(new Date('2020-06-18T00:00:54'));
    const [error, setError] = useState(false)

    useEffect(() => {
      if (endTime - startTime > 0) {
        onChange({ startTime, endTime }, index)
        setError(false)
      } else {
        setError(true)
      }
    }, [startTime, endTime])

    useEffect(()=> {
      if (defaultValue) {
        setStartTime(new Date(removeLastChar(defaultValue.startTime)))
        setEndTime(new Date(removeLastChar(defaultValue.endTime)))
      }
    },[])


    const handleDateChange = (date) => {
        setStartTime(date);
      };
    
      const handleChangeEndTime = (date) => {
        setEndTime(date);
      }
    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Grid container justify="space-around">
            <KeyboardTimePicker
              margin="normal"
              id="time-picker"
              label="Time picker"
              value={startTime}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change time',
              }}
            />
          </Grid>
          <Grid container justify="space-around">
            <KeyboardTimePicker
              margin="normal"
              id="time-picker"
              label="Time picker"
              value={endTime}
              error={error}
              helperText={error ? 'End Time should be greater than start time' : ''}
              onChange={handleChangeEndTime}
              KeyboardButtonProps={{
                'aria-label': 'change time',
              }}
            />
          </Grid>
        </div>
      </MuiPickersUtilsProvider>
    )
}